import React from 'react';
import { createEmptyUserSession } from './auth.vm';
export const AuthContext = React.createContext(Object.assign(Object.assign({}, createEmptyUserSession()), { refresh: () => { }, setUserSession: () => { }, urlLocale: React.createRef() }));
export const useAuthContext = () => React.useContext(AuthContext);
